// extracted by mini-css-extract-plugin
export var lg = "_1s-4";
export var md = "_1s-3";
export var sm = "_1s-2";
export var xs = "_1s-1";
export var xxs = "_1s-0";